import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AnalyticsService } from 'app/shared/services/analytics.service';
import { AttributionService } from 'app/shared/services/attribution.service';
import { anonimizarRuta } from 'app/shared/utils/ruta-anonima';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    private _ultimaRuta: string | null = null;

    /**
     * Constructor
     */
    constructor(
        private _attributionService: AttributionService,
        private _analytics: AnalyticsService,
        private _router: Router,
    ) {
        // Captura el origen de la visita antes de que el router limpie la URL.
        this._attributionService.capture();

        // Vista de pagina en cada navegacion, incluida la carga inicial (el
        // primer NavigationEnd): index.html configura GA con send_page_view:
        // false para que la URL completa, con tokens, nunca llegue a Google.
        this._router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event) => {
                const ruta = anonimizarRuta(event.urlAfterRedirects);
                // Quitar el token de la barra (replaceUrl) es otra navegacion a
                // la misma ruta: no es otra vista de pagina.
                if (ruta === this._ultimaRuta) return;
                this._ultimaRuta = ruta;
                this._analytics.pageView(ruta);
            });
    }
}
